export interface MapPoint {
  x: number;
  y: number;
}

export interface MapRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function normalizeRect(start: MapPoint, end: MapPoint): MapRect {
  const x = Math.min(start.x, end.x);
  const y = Math.min(start.y, end.y);
  return {
    x,
    y,
    width: Math.abs(end.x - start.x),
    height: Math.abs(end.y - start.y)
  };
}

export function pointInRect(point: MapPoint, rect: MapRect): boolean {
  return (
    point.x >= rect.x &&
    point.x <= rect.x + rect.width &&
    point.y >= rect.y &&
    point.y <= rect.y + rect.height
  );
}

/** Ray-casting algorithm for point-in-polygon test. */
export function pointInPolygon(point: MapPoint, polygon: MapPoint[]): boolean {
  if (polygon.length < 3) {
    return false;
  }

  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x;
    const yi = polygon[i].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;

    const intersects =
      yi > point.y !== yj > point.y &&
      point.x < ((xj - xi) * (point.y - yi)) / (yj - yi + Number.EPSILON) + xi;

    if (intersects) {
      inside = !inside;
    }
  }
  return inside;
}

export function pointsToSvgPoints(points: MapPoint[]): string {
  return points.map(p => `${p.x},${p.y}`).join(' ');
}

export function rectMeetsMinimumSize(rect: MapRect, minSize = 6): boolean {
  return rect.width >= minSize && rect.height >= minSize;
}
